import babelpolyfill from 'babel-polyfill'
import Vue from 'vue'
import App from './App'

// 饿了吗pc端
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-default/index.css'
//import './assets/theme/theme-green/index.css'
import VueRouter from 'vue-router'
import store from './vuex/store'
import Vuex from 'vuex'
//import NProgress from 'nprogress'
//import 'nprogress/nprogress.css'
import routes from './routes'
//前后端分离请求拦截本地数据模拟测试
// import Mock from './mock'
// Mock.bootstrap(); 
import 'font-awesome/css/font-awesome.min.css'
//权限列表
import userlist from './userroutes/routeschange'
import landlordlist from './userroutes/landlord'
import oneCardSystem from './userroutes/OneCardSystem'

import caiwulist from './userroutes/caiwu'
import qiantailist from './userroutes/qiantai'
import jiaolianlist from './userroutes/jiaolian'
import shuizhilist from './userroutes/shuizhi'
import shuidianlist from './userroutes/shuidian'


import Axios from 'axios'

Vue.prototype.$axios = Axios
//dev
Axios.defaults.baseURL = 'api'
Axios.defaults.headers.post['Content-Type'] = 'application/json';

// 移动端
// import MuseUI from 'muse-ui';
// import 'muse-ui/dist/muse-ui.css';

// Vue.use(MuseUI);
Vue.use(ElementUI)
Vue.use(VueRouter)
Vue.use(Vuex)
  const router = new VueRouter({
    mode:'history',
    routes:routes
    
  })

 

// 路由拦截 进入前 进入后 当前只做进入前
router.beforeEach((to, from, next) => {

   //微信入口页 和回调页不 路由不设限
  if(to.path==='/OAuth'||to.path==='/WeiXinMain')
  {
    next()
  }else
  {
    if(to.path === '/login')  {  next()  }
    else {     //进入的不是登录路由
         
      if(!sessionStorage.getItem('user'))
       {next({ path: '/login' })} 
  
      //下一跳路由需要登录验证，并且还未登录，则路由定向到  登录路由
  
      else {
        
        var routerState=store.state.routerState;
        // console.log('一登陆需要路由'+routerState+'---');
 if(routerState==='true')
 {
   next()
 }
 else
 {
   let user={};
   user=JSON.parse(sessionStorage.getItem('user'));
  // console.log('user panduan'+'---'+user);
  if(user.UserLevel==3){
    oneCardSystem.forEach(item=>{
      router.options.routes.push(item);
		})
		router.addRoutes(oneCardSystem)
		store.state.routerState='true';
		//模仿重定向
		next({ path:'/' }) 
		next({ path:to.path }) 
	}else if(user.UserLevel==1){
		userlist.forEach(item=>{
			router.options.routes.push(item);
		})
		router.addRoutes(userlist)
		store.state.routerState='true';
		next({ path:'/'})
		next({ path:to.path})
  }else if(user.UserLevel==6){
		caiwulist.forEach(item=>{
			router.options.routes.push(item);
		})
		router.addRoutes(caiwulist)
		store.state.routerState='true';
		next({ path:'/'})
		next({ path:to.path})
  }else if(user.UserLevel==0){
		qiantailist.forEach(item=>{
			router.options.routes.push(item);
		})
		router.addRoutes(qiantailist)
		store.state.routerState='true';
		next({ path:'/'})
		next({ path:to.path})
  }else if(user.UserLevel==7){
		jiaolianlist.forEach(item=>{
			router.options.routes.push(item);
		})
		router.addRoutes(jiaolianlist)
		store.state.routerState='true';
		next({ path:'/'})
		next({ path:to.path})
  }else if(user.UserLevel==4){
		shuizhilist.forEach(item=>{
			router.options.routes.push(item);
		})
		router.addRoutes(shuizhilist)
		store.state.routerState='true';
		next({ path:'/'})
		next({ path:to.path})
  }else if(user.UserLevel==5){
		shuidianlist.forEach(item=>{
			router.options.routes.push(item);
		})
		router.addRoutes(shuidianlist)
		store.state.routerState='true';
		next({ path:'/'})
		next({ path:to.path})
  }else{
    if(user.TenancyId==0||user.TenancyId==null){
			landlordlist.forEach(item=>{
				router.options.routes.push(item);
			})
       router.addRoutes(landlordlist)
       store.state.routerState='true';
       //模仿重定向
       next({ path:'/' }) 
       next({ path:to.path })
    }else{
			userlist.forEach(item=>{
				router.options.routes.push(item);
			})
      router.addRoutes(userlist)
      store.state.routerState='true';
      //模仿重定向
      next({ path:'/'})
      next({ path:to.path})
    }
  }



 }    
      }}  //如果不需要登录验证，或者已经登录成功，则直接放行
  
  }

      
    
})

router.afterEach((to, from) => {
  //会在任意路由跳转后执行
   //微信入口页 和回调页不 路由不设限
   
})

new Vue({
  //el: '#app',
  //template: '<App/>',
  router,
  store,
  //components: { App }
  render: h => h(App)
}).$mount('#app')




// WEBPACK FOOTER //
// ./src/main.js